export default "/images/add12d9658f894c55251ed38bdacff79.avif";